import { useState } from "react";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../Localization/Translation";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DetailedRequest from "./DetailedRequest/DetailedRequest.js";
import Footer from "../Footer/Footer";

const DeliveryRepresentatives = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (laundryId) => {
    setShow(true);
  };

  var DeliveryRepresentativesItems = [
    {
      id: 1,
      name: "ياسر النايف",
      date: "25/12/2020",
      phone: "0968820968",
      relativePhone: "0968820967",
      relativeRelation: "قريب",
      nationality: "سعودي",
      IdOrPassport: "https://via.placeholder.com/200x150",
      Address: "عنوان الإفامة",
      VehicleType: "نوع المركبة",
      VehicleColor: "أحمر",
      VehicleNum: "رقم المركبة",
      VehicleLicence: "https://via.placeholder.com/200x150",
    },
    {
      id: 2,
      name: "ياسر النايف",
      date: "25/12/2020",
      phone: "0968820968",
      relativePhone: "0968820967",
      relativeRelation: "قريب",
      nationality: "سعودي",
      IdOrPassport: "https://via.placeholder.com/200x150",
      Address: "عنوان الإفامة",
      VehicleType: "نوع المركبة",
      VehicleColor: "أحمر",
      VehicleNum: "رقم المركبة",
      VehicleLicence: "https://via.placeholder.com/200x150",
    },
    {
      id: 3,
      name: "ياسر النايف",
      date: "25/12/2020",
      phone: "0968820968",
      relativePhone: "0968820967",
      relativeRelation: "قريب",
      nationality: "سعودي",
      IdOrPassport: "https://via.placeholder.com/200x150",
      Address: "عنوان الإفامة",
      VehicleType: "نوع المركبة",
      VehicleColor: "أحمر",
      VehicleNum: "رقم المركبة",
      VehicleLicence: "https://via.placeholder.com/200x150",
    },
    {
      id: 4,
      name: "ياسر النايف",
      date: "25/12/2020",
      phone: "0968820968",
      relativePhone: "0968820967",
      relativeRelation: "قريب",
      nationality: "سعودي",
      IdOrPassport: "https://via.placeholder.com/200x150",
      Address: "عنوان الإفامة",
      VehicleType: "نوع المركبة",
      VehicleColor: "أحمر",
      VehicleNum: "رقم المركبة",
      VehicleLicence: "https://via.placeholder.com/200x150",
    },
  ];
  let d = "-1";
  const DeliveryRepresentativesList = DeliveryRepresentativesItems.map(
    (Item, index) => {
      d = Number(d) + 1;
      return (
        <div
          className={
            "LaundryOwners-list animate__animated animate__fadeInUp animate__delay-" +
            d +
            "s"
          }
          key={Item.id}
          id={Item.id}
        >
          <div className="request-card row" dir="auto">
            <div
              className="col-md-8 request-card-col main-data-request-card-col"
              dir="auto"
            >
              <div className="header-join-req-card">
                <span>
                  <i className="fa fa-user" aria-hidden="true"></i>
                  {translate("delivery-person-name", locale)}:
                </span>
                <span>{Item.name}</span>
              </div>
              <div className="date-join-req-card">
                <span>
                  <i className="fa fa-calendar" aria-hidden="true"></i>
                  {translate("date-of-join", locale)}:
                </span>
                <span>{Item.date}</span>
              </div>
            </div>
            <div className="col-md request-card-col detail-btn-request-card-col">
              <button className="btn btn-primary" onClick={handleShow}>
                {translate("del-details-btn", locale)}
              </button>
            </div>
          </div>
        </div>
      );
    }
  );
  return (
    <div>
      <div className="main-component">
        <div className="LaundryOwners">
          <div className="header-filter-laundries">
            <div className="SearchWasher">
              {/* <!-- Actual search box --> */}
              <div
                className="form-group has-search "
                dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
              >
                <i className="bi bi-search form-control-feedback"></i>
                <input
                  type="text"
                  className="form-control search-washer-input-placeholder"
                  placeholder={translate("Search-box-placeholder", locale)}
                />
              </div>
            </div>
          </div>

          {DeliveryRepresentativesList}
        </div>

        <Modal show={show} onHide={handleClose} size="md" dir="auto">
          <Modal.Header className="modal-header">
            {translate("del-details-btn", locale)}
          </Modal.Header>
          <Modal.Body>
            <DetailedRequest />
          </Modal.Body>
          <Modal.Footer dir="auto">
            <Button variant="secondary" onClick={handleClose}>
              {translate("modal-close-btn", locale)}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Footer />
    </div>
  );
};

export default DeliveryRepresentatives;
